import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TranslocoModule } from '@jsverse/transloco';
import { MY_FORMATS } from 'app/components/mapa/menu/filtro-mapa/filtro-mapa.component';
import { PadraoDatapicket } from 'app/interfaces/compartilhados/Inputs';
import { CustomDateAdapter } from 'app/services/dataConfig/CustomDateAdapter';

@Component({
  selector: 'app-data-picker-padrao',
  standalone: true,
  imports: [MatDatepickerModule, CommonModule, ReactiveFormsModule, TranslocoModule],
  providers:[[
      provideNativeDateAdapter(),
      { provide: DateAdapter, useClass: CustomDateAdapter, deps: [MAT_DATE_LOCALE] },
      { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
      { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    ]],
  templateUrl: './data-picker-padrao.component.html',
  styleUrl: './data-picker-padrao.component.css'
})
export class DataPickerPadraoComponent implements OnInit {
  @Input() public quantMesLimite: Date | boolean = false;
  @Input() public width:number =  13.5;
  
  @Output() eventoDatepicker: EventEmitter<PadraoDatapicket> = new EventEmitter<PadraoDatapicket>();
  public dataMax!: Date;
  constructor(private adapter: DateAdapter<any>) {
    this.mudarIdioma("pt-BR")
  }
  
  mudarIdioma(idioma: string): void {
    this.adapter.setLocale(idioma);
  }
  public formularioFiltros:FormGroup = new FormGroup({
    dataInicio: new FormControl<Date | null>(null),
    dataFim: new FormControl<Date | null>(null)
  });
  
  ngOnInit(): void {
    this.formularioFiltros = new FormGroup({
        dataInicio: new FormControl<Date | null>(null),
        dataFim: new FormControl<Date | null>(null)
      });
  }
  public atualizarDataMax(): void {
    if(this.quantMesLimite) {
      let dataInicio: Date = this.formularioFiltros.get('dataInicio')?.value!;
      let novaDataMax: Date = new Date(dataInicio);
      novaDataMax.setMonth(novaDataMax.getMonth() + 2);
      this.dataMax = novaDataMax;
    }
  }

  public emitirData(): void {
    const dados: PadraoDatapicket = {
      dataFim: this.formularioFiltros.get('dataFim')?.value!,
      dataInicio: this.formularioFiltros.get('dataInicio')?.value!
    }
    this.eventoDatepicker.emit(dados);
  } 
}

